import React from 'react';
import { Link } from 'react-router-dom';
import { Input } from 'reactstrap';
import { Btn, H6 } from '../../../AbstractElements';
import { getallCardTotal } from '../../../Services/Ecommerce.service';
import { Apply, CheckOut, ContinueShopping, TotalPrice } from '../../../Constant';

const CartFooter = ({ symbol, cart }) => {
  return (
    <>
      <tr>
        <td colSpan='4'>
          <div className='input-group'>
            <Input className='form-control' type='text' placeholder='Enter coupon code' />
            <Btn color='primary'>{Apply}</Btn>
          </div>
        </td>
        <td className='total-amount'>
          <H6 className='m-0 text-end'>
            <span className='f-w-600'>{TotalPrice} :</span>
          </H6>
        </td>
        <td>
          <span>
            {symbol}
            {getallCardTotal(cart)}
          </span>
        </td>
      </tr>
      <tr>
        <td className='text-end' colSpan='5'>
          <Link className='btn btn-secondary cart-btn-transform' to={`${process.env.PUBLIC_URL}/ecommerce/product`}>
            {ContinueShopping}
          </Link>
        </td>
        <td>
          <Link className='btn btn-success cart-btn-transform' to={`${process.env.PUBLIC_URL}/ecommerce/checkout`}>
            {CheckOut}
          </Link>
        </td>
      </tr>
    </>
  );
};

export default CartFooter;
